import type React from "react";

import { EventColour } from "../components/overlay/types";
import theme from "../theme/coretex-theme";

export default (eventColour: EventColour): React.CSSProperties["color"] => {
  switch (eventColour) {
    case EventColour.Warning:
      return theme.palette.colour.yellow;
    case EventColour.Exception:
      return theme.palette.colour.red;
    case EventColour.General:
    default:
      return theme.palette.mono.primaryDark;
  }
};
